"use client";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { verticalSlidesData } from "@/utils/DemoData";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ReactSVG } from "react-svg";

import "./LumberProducts.scss";
import { useRouter } from "next/navigation";
import { useMediaQuery } from "@mui/material";
import { ApiResponse, Product } from "@webelocity/core";;
import { shopApi } from "@/lib/shopApi";
import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { categoriesAtom } from "@webelocity/state";
import { chunkArray } from "@/utils/helpers";
import { Skeleton } from "@mui/material";
import SectionOverlay from "@/components/Shared/SectionOverlay/SectionOverlay";
import { motion } from "framer-motion";
import { slideFromLeft, fadeUp, defaultViewport } from "@/utils/animations";
import { ProductCard } from "@webelocity/ui";
const LumberProducts = () => {
  const router = useRouter();
  const cat_id = "6846c4f6550f9ca64f6e70d7"
  const isMobile = useMediaQuery("(max-width:1023px)");
  const {
    data: productsResponse,
    isLoading,
    isError,
  } = useQuery<ApiResponse<Product>>({
    queryKey: [cat_id],
    queryFn: () => shopApi.fetchAllProducts({ isFeatured: true }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
  const AllCats = useAtomValue(categoriesAtom)
  const Category = AllCats.find((cat) => cat._id === cat_id)
  if (productsResponse?.data?.length === 0) {
    return null;
  }
  return (
    <div className="lumber-products-wrapper baseContainer" style={{ position: "relative" }}>
      <div className="maxWidth">
      {/* <SectionOverlay message="Catalog Coming Soon" /> */}
      <motion.div
        className="left"
        variants={slideFromLeft}
        initial="hidden"
        whileInView="visible"
        viewport={defaultViewport}
      >
        <p className="section-main-header large white">
          <span>This</span> Week Features
        </p>

        <p className="text-small-20">Sign Up Today for Exclusive Discounts!</p>

        <button
          className="main-btn yellow"
          onClick={() => router.push(`/shop/catalogue?cat=${Category?._id}`)}
        >
          Shop All
        </button>
      </motion.div>

      <motion.div
        className="right"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={defaultViewport}
      >
        <div className="header-wrapper">
          <h3 className="section-main-header">Featured Products </h3>

          {!isMobile && (
            <div className="navigation">
              <div className="prev-arrow-lumber">
                <ReactSVG
                  src={"/assets/swiper-prev-ic.svg"}
                  width={25}
                  height={25}
                />
              </div>

              <div className="swiper-pagination-lumber"></div>

              <div className="next-arrow-lumber">
                <ReactSVG
                  src={"/assets/swiper-next-ic.svg"}
                  width={25}
                  height={25}
                />
              </div>
            </div>
          )}
        </div>

        <Swiper
          navigation={{
            nextEl: ".next-arrow-lumber",
            prevEl: ".prev-arrow-lumber",
          }}
          pagination={{
            clickable: true,
            el: ".swiper-pagination-lumber",
            type: "bullets",
          }}
          modules={[Navigation, Pagination]}
          slidesPerView={isMobile ? 1 : 3}
          spaceBetween={16}
        >
          {isLoading ? (
            Array.from({ length: isMobile ? 1 : 3 }).map((_, idx) => (
              <SwiperSlide className="slide stacked" key={idx}>
                <div className="SwiperVerticalCard-wrapper loading">
                  <div className="image-container">
                    <Skeleton variant="rectangular" width="100%" height={185} />
                  </div>
                  <div className="details-container">
                    <Skeleton variant="text" width="80%" height={24} style={{ marginBottom: 8 }} />
                    <Skeleton variant="text" width="60%" height={18} style={{ marginBottom: 8 }} />
                    <Skeleton variant="rectangular" width="40%" height={28} />
                  </div>
                </div>
              </SwiperSlide>
            ))
          ) : productsResponse && productsResponse.totalItems > 0 ? (
            productsResponse.data.map((product, productIndex) => (
              <SwiperSlide className="slide stacked" key={productIndex}>
                <ProductCard
                  key={productIndex}
                  product={product}
                />
              </SwiperSlide>
            ))
          ) : (
            <SwiperSlide className="slide stacked" key="no-products">
              <div className="text-medium-28 blue-500">
                No Products Available
              </div>
            </SwiperSlide>
          )}
        </Swiper>

        {isMobile && (
          <div className="navigation">
            <div className="prev-arrow-lumber">
              <ReactSVG
                src={"/assets/swiper-prev-ic.svg"}
                width={25}
                height={25}
              />
            </div>

            <div className="swiper-pagination-lumber"></div>

            <div className="next-arrow-lumber">
              <ReactSVG
                src={"/assets/swiper-next-ic.svg"}
                width={25}
                height={25}
              />
            </div>
          </div>
        )}
      </motion.div>
      </div>
    </div>
  );
};

export default LumberProducts;
